<template>
  <div class="mt-60">
    <div class="boires-page-loader-div" v-if="isLoading">
      <div class="boires-page-loader"></div>
    </div>
    <MainLayout>
      <div class="container text-left">
        <h2 class="title text-left">
          {{ titleSection }}
        </h2>
      </div>

      <FilterBar
        id="filter-bar"
        :filter-count="filterCount"
        @emit-filter-reset="emitResetFilters"
        @emit-filter-click="emitToggleFilter"
        @emit-pdf-download="generatePdf"
        :show-filter="false"
      />

      <div id="providers" class="mt-16">
        <el-row>
          <mq-layout
            v-if="isMounted"
            :mq="['xs', 'sm', 'md']"
            class="container"
          >
            <el-col :span="24">
              <ProviderCardsList
                v-if="
                  changeProviderView &&
                  providers &&
                  providers.results &&
                  providers.results.length > 0
                "
                id="provider-cards-list-md"
                :providers="providers && providers.results"
                :span="12"
                :filters="filters"
                :list-type="viewType"
              />
            </el-col>
          </mq-layout>
          <mq-layout v-if="isMounted" mq="lg+" class="container">
            <el-col :span="isFilterVisible ? 4 : 0">
              <ProviderFilters
                :filters="filters"
                :attributes-model="selectedFilters.attributes"
                :countries-model="selectedFilters.countries"
                :regions-model="selectedFilters.regions"
                :filter-reset="filterReset"
                @filter-change="updateSelectedFilters"
                @filter-reset="initFilterReset"
              />
            </el-col>
            <el-col :span="isFilterVisible ? 20 : 24" id="print">
              <div ref="createPdf">
                <ProviderCardsList
                  v-if="
                    changeProviderView &&
                    providers &&
                    providers.results &&
                    providers.results.length > 0
                  "
                  id="provider-cards-list-lg"
                  :providers="providers && providers.results"
                  :span="$mq === 'lg' ? 8 : 6"
                  :is-filter-visible="isFilterVisible"
                  :filters="filters"
                  :list-type="viewType"
                />
                <vue-html2pdf
                  :show-layout="false"
                  :float-layout="true"
                  :enable-download="true"
                  :preview-modal="true"
                  :paginate-elements-by-height="1400"
                  :pdf-quality="2"
                  :manual-pagination="true"
                  pdf-format="a4"
                  pdf-orientation="landscape"
                  pdf-content-width="100%"
                  :html-to-pdf-options="htmlToPdfOptions"
                  ref="html2Pdf"
                >
                  <section slot="pdf-content">
                    <div class="pdf-logo mb-20">
                      <img :src="image.logo" alt="" class="pdf-logo-img" />
                    </div>
                    <ProviderCardsList
                      v-if="
                        changeProviderView &&
                        providers &&
                        providers.results &&
                        providers.results.length > 0
                      "
                      id="provider-cards-list-lg"
                      :providers="providers && providers.results"
                      :span="$mq === 'lg' ? 8 : 6"
                      :is-filter-visible="isFilterVisible"
                      :filters="filters"
                      :list-type="viewType"
                    />
                  </section>
                </vue-html2pdf>
              </div>
            </el-col>
          </mq-layout>
        </el-row>
      </div>

      <div>
        <el-row>
          <div class="container">
            <el-divider class="mt-4 mb-4" />
            <el-col :span="24">
              <div :class="isMobileLayout ? 'text-center' : 'text-right'">
                <Pagination
                  :current-page="currentPage"
                  :total-number-of-page="totalNumberOfPage"
                  @click-previous="clickPrevious"
                  @click-next="clickNext"
                />
              </div>
            </el-col>
          </div>
        </el-row>
      </div>

      <el-drawer
        id="drawer"
        ref="drawer"
        title="Filtrer"
        :visible.sync="isMobileFilterVisible"
        :direction="direction"
        :before-close="handleClose"
        :size="drawerSize"
        :class="isMobileFilterVisible && $mq == 'sm' && 'filter-full'"
      >
        <div class="filter--mobile">
          <ProviderFilters
            :filters="filters"
            :attributes-model="selectedFilters.attributes"
            :countries-model="selectedFilters.countries"
            :regions-model="selectedFilters.regions"
            :filter-reset="filterReset"
            @filter-change="updateSelectedFilters"
          />
          <div v-if="isMobileLayout" class="mt-16 mr-16 text-right">
            <el-button @click="handleClose">
              {{ cancelButton }}
            </el-button>
            <el-button type="primary">
              {{ filterButton }}
            </el-button>
          </div>
        </div>
      </el-drawer>
    </MainLayout>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import { ceil } from "@/utils/lodash";
import layoutUtils from "@/utils/layout-utils";

import FilterBar from "@/components/filter-bar.vue";
import MainLayout from "@/components/layout/main-layout.vue";
import Pagination from "@/components/pagination.vue";

import ProviderFilters from "./components/provider-filters.vue";
import ProviderCardsList from "./components/provider-cards-list.vue";

import VueHtml2pdf from "vue-html2pdf";
import pdfLogo from "@/assets/images/logo/logo-red.png";

export default {
  components: {
    MainLayout,
    FilterBar,
    Pagination,
    ProviderFilters,
    ProviderCardsList,
    VueHtml2pdf,
  },
  props: {
    type: {
      type: String,
      default: "QC",
    },
    page: {
      type: Number,
      default: 1,
    },
    attributesModel: {
      type: Array,
      default: () => [],
    },
    countriesModel: {
      type: Array,
      default: () => [],
    },
    regionsModel: {
      type: Array,
      default: () => [],
    },
    textModel: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      filterCount: 0,
      selectedFilters: {
        attributes: [],
        countries: [],
        regions: [],
        text: this.textModel,
      },
      isMobileFilterVisible: false,
      isFilterVisible: true,
      drawer: false,
      direction: "ltr",
      isMounted: false,
      filterReset: false,
      currentPage: 1,
      viewType: "tuiles",
      htmlToPdfOptions: {
        margin: [0.1, 0.2, 0.3, 0],
        filename: `${Math.round(+new Date() / 1000)}.pdf`,
        image: {
          type: "jpeg",
          quality: 2,
        },
        enableLinks: false,
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          unit: "in",
          format: "a4",
          orientation: "portrait",
        },
      },
      image: {
        logo: pdfLogo,
      },
      changeProviderView: true,
      isLoading: true,
    };
  },
  computed: {
    ...mapState("provider", [
      "providers",
      "filters",
      "providersAvailableLayout",
    ]),
    ...mapState("configuration", ["actionBar"]),
    titleSection() {
      return this.$i18n.t("providers.providersView.title.section");
    },
    titleType() {
      return this.$i18n.t(`providers.providersView.title.type.${this.type}`);
    },
    titleGoTo() {
      const goToType = this.type === "QC" ? "ON" : "QC";
      return this.$i18n.t(`providers.providersView.title.type.${goToType}`);
    },
    titleSearch() {
      return this.$i18n.t("providers.providersView.title.search");
    },
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
    drawerSize() {
      return this.innerWidth <= 414 ? "100%" : "414px";
    },
    cancelButton() {
      return this.$i18n.t("providers.filters.button.cancel");
    },
    filterButton() {
      return this.$i18n.t("providers.filters.button.filter");
    },
    numberOfProviderPerPage() {
      switch (this.$mq) {
        case "xs":
        case "sm":
        case "md":
          return 20;
        case "lg":
          return 51;
        default:
          return 52;
      }
    },
    totalNumberOfPage() {
      const numberOfPages =
        this.providers &&
        ceil(this.providers.total / this.numberOfProviderPerPage);
      return numberOfPages != null && numberOfPages > 0 ? numberOfPages : 1;
    },
  },
  watch: {
    type() {
      this.getProviders({
        page: this.currentPage,
        size: this.numberOfProviderPerPage,
        attributes: [],
        countries: this.countriesModel,
        regions: this.regionsModel,
        text: this.textModel,
        req: true,
      });
    },
    numberOfProviderPerPage() {
      this.redirectAfterPageChange();
    },
  },
  created() {
    if (this.actionBar.country !== this.type) {
      this.setActionBarCountry({
        country: this.type,
      });
    }

    this.currentPage = this.page;

    this.getProviders({
      page: this.currentPage,
      size: this.numberOfProviderPerPage,
      attributes: this.attributesModel,
      countries: this.countriesModel,
      regions: this.regionsModel,
      text: this.textModel,
    });

    if (!this.validateCurrentPage()) {
      this.getProviders({
        page: this.currentPage,
        size: this.numberOfProviderPerPage,
        attributes: this.attributesModel,
        countries: this.countriesModel,
        regions: this.regionsModel,
        text: this.textModel,
      });
    }

    this.fetchProviderFilters({});
  },
  mounted() {
    // this.updateSelectedFilters({
    //   attributes: this.attributesModel,
    //   countries: this.countriesModel,
    //   regions: this.regionsModel,
    // });

    this.updateFiltersCount();
    this.$root.$on("chanLang", () => {
      this.fetchProviderFilters({});
    });
    this.isMounted = true;
    this.$root.$on("viewType", (viewType) => {
      this.viewType = viewType;
      this.changeProviderView = false;
      this.$nextTick(() => {
        this.changeProviderView = true;
      });
    });
  },
  methods: {
    ...mapActions("provider", ["fetchProviders", "fetchProviderFilters"]),
    ...mapActions("configuration", ["setActionBarCountry"]),
    getProviders(filters) {
      // if (!this.providers.results || filters.req == true) {
        this.isLoading = true;
        this.fetchProviders({
          type: this.type,
          filters,
        }).then(()=>{
          this.isLoading = false;
          this.changeProviderView = false;
          this.$nextTick(() => {
            this.changeProviderView = true;
          });
        })
        .catch(()=>{
          this.isLoading = false;
          this.changeProviderView = false;
          this.$nextTick(() => {
            this.changeProviderView = true;
          });
        });
      // }
      // setTimeout(() => {
      //   this.isLoading = false;
      // }, 2000);
    },
    updateSelectedFilters(filters) {
      this.isLoading = true;
      if (filters.attributes != null) {
        this.selectedFilters.attributes = filters.attributes;
      }

      if (filters.countries != null) {
        this.selectedFilters.countries = filters.countries;
      }

      if (filters.regions != null) {
        this.selectedFilters.regions = filters.regions;
      }

      if (filters.text != null) {
        this.selectedFilters.text = filters.text;
      }

      this.validateCurrentPage();

      this.selectedFilters.req = filters.req == true ? true : false;
      this.selectedFilters.page = this.currentPage;
      this.selectedFilters.size = this.numberOfProviderPerPage;

      this.updateFiltersCount();
      this.getProviders(this.selectedFilters);
    },
    validateCurrentPage() {
      if (this.totalNumberOfPage && this.totalNumberOfPage < this.currentPage) {
        this.currentPage = this.totalNumberOfPage;
        return false;
      }

      return true;
    },
    updateFiltersCount() {
      this.filterCount =
        this.selectedFilters.attributes.length +
        this.selectedFilters.countries.length +
        this.selectedFilters.regions.length;
    },
    emitResetFilters() {
      this.filterReset = true;

      this.redirect({
        page: this.currentPage,
        size: this.numberOfProviderPerPage,
        a: [],
        c: [],
        r: [],
        req: true,
      });
    },
    emitToggleFilter() {
      if (this.isMobileLayout) {
        this.isMobileFilterVisible = !this.isMobileFilterVisible;
      } else {
        this.isFilterVisible = !this.isFilterVisible;
      }
    },
    handleClose() {
      this.isMobileFilterVisible = false;
    },
    initFilterReset() {
      this.filterReset = false;
    },
    clickPrevious() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
        this.redirectAfterPageChange();
      }
    },
    clickNext() {
      if (this.currentPage < this.totalNumberOfPage) {
        this.currentPage += 1;
        this.redirectAfterPageChange();
      }
    },
    redirectAfterPageChange() {
      this.updateSelectedFilters({
        attributes: this.attributesModel,
        countries: this.countriesModel,
        regions: this.regionsModel,
        req: true,
      });
      this.redirect(this.selectedFilters);
    },
    redirect(filters) {
      this.$router
        .push({
          query: {
            ...this.$route.query,
            page: filters.page,
            a: filters.attributes,
            c: filters.countries,
            r: filters.regions,
          },
        })
        .catch(() => {});
    },
    async generatePdf() {
      this.generateReport();
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables.scss";

.title {
  color: $color-on-background-area2;
  margin-bottom: 20px;
}
.filter--mobile {
  height: 400px;
}
.drawer {
  position: relative;
  height: 100%;
}
.el-drawer__header__child {
  text-align: left !important;
  font-family: $font-family-bold;
  font-weight: $font-weight-bold;

  @media screen and (min-width: $media-sm) {
    font-size: 18px;
    letter-spacing: 0.15px;
  }

  @media screen and (max-width: $media-sm) {
    font-size: 18px;
    letter-spacing: 0.15px;
  }
}
.pdf-logo {
  text-align: center;
  .pdf-logo-img {
    width: 250px;
  }
}
#product-cards-pdf {
  .type-heading-main {
    h1 {
      font-size: 20px !important;
    }
  }
}
</style>
